<template>
  <div>
    <ArticleList v-if="list.length < 2" :list="dataList" :type="active" />
    <van-tabs v-else v-model="activeTab" swipeable animated :swipe-threshold="4" @change="getCatDataList">
      <van-tab v-for="(item, index) in list" :key="index" :title="item.label" :name="item.name">
        <ArticleList ref="articleList" :list="dataList" :type="item.name" />
      </van-tab>
    </van-tabs>
  </div>
</template>

<script>
import { http } from '@/api'
import { PublicMiniSite, Event } from '@/api/collection'
// import { Tab, Tabs } from 'vant'
import ArticleList from './ArticleList'
import { common } from './common/mixin.js'
export default {
  name: 'ArticleTabs',
  components: {
    ArticleList
  },
  mixins: [common],
  props: {
    list: {
      type: Array,
      default: () => []
    },
    active: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      form: {
        filter: '',
        pageIndex: 0,
        pageSize: 50,
        types: [],
        sortBy: '',
        titles: [],
        lang: '',
        status: '2'
      },
      campaignCode: '',
      dataList: []
    }
  },
  computed: {
    // lang() {
    //   return this.$store.getters.language
    // },
    activeTab: {
      set() {},
      get() {
        return this.active || ''
      }
    }
  },
  watch: {
    'list': {
      handler(val) {
        // const name = this.list && this.list[0].name
        if (val && val.length > 0) {
          if (val[0].name === 'event') {
            this.getEventsByCodeLang({ campaignCode: this.campaignCode, lang: this.lang })
          } else {
            this.form.types = [val[0].name]
            this.getArticles()
          }
        }
      },
      deep: true
    }
  },
  mounted() {
    this.campaignCode = this.$route.query.param
  },
  methods: {
    // tab切换
    getCatDataList(name, title) {
      if (name === 'event') {
        this.getEventsByCodeLang({ campaignCode: this.campaignCode, lang: this.lang })
      } else {
        this.form.types = [name]
        this.getArticles()
      }
    },
    // 获取文章列表
    async getArticles() {
      this.form.lang = this.lang
      const res = await http({
        path: PublicMiniSite.GetArticles.path,
        method: PublicMiniSite.GetArticles.method,
        data: this.form
      })

      if (res.resultCode === '0') {
        this.dataList = res.data.items
      }
    },
    // 获取活动列表
    async getEventsByCodeLang(data) {
      const res = await http({
        path: Event.GetEventsByCodeLang.path,
        method: Event.GetEventsByCodeLang.method,
        data
      })
      if (res.resultCode === '0') {
        this.dataList = res.data
      }
    }
  }
}
</script>

<style lang="scss">
.van-tabs--line .van-tabs__wrap {
  height: 0.88rem;
}
.van-tabs__nav--line {
  padding-bottom: 0.3rem;
}
.van-tab {
  font-size: 0.28rem;
}
.van-tabs__line {
  width: 1.82rem;
    bottom: 0.3rem;
    height: 0.06rem;
    border-radius: 0.06rem;
}
</style>
